<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <form @submit.prevent="changeLostPipeline" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('pipelines.addMotif') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                        <span class="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                  fill="currentColor" />
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                  fill="currentColor" />
                            </svg>
                        </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText/>
            <Select2
                :is-required="true"
                container-class="col-12 col-md-12 mb-2 mt-2"
                :multiple="false"
                :show-search="true"
                :selectClass="'form-select form-control-lg form-select-solid'"
                name="pipelines-reasons"
                :label="$t('pipelines.label.reasons')"
                label-class="form-label"
                v-model="formLostData.reason_id"
                :placeholder-text="$t('pipelines.label.select_reasons')"
            >
              <option v-for="(item, index) in reasons" :key="index" :value="item.id">{{ item.name }} </option>
            </Select2>
            <InputDate2
                id="loose-date"
                containerClass="col-12 col-md-12 mt-2 mb-2"
                name="pipelines-date"
                :label="$t('pipelines.label.opportunity_closing_date')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :isRequired="true" size="lg"
                v-model="formLostData.date"
                :placeholder="$t('pipelines.label.opportunity_closing_date')"
            />
            <CKEditor id="motif-editor" :required="false" :label="$t('pipelines.label.motif')" :content="formLostData.loss_motif" container-class="col-12 col-md-12 mb-2 mt-2" @text="getMotif" />
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingLost"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

  import { computed, ref, defineProps } from "vue";
  import {useStore} from "vuex";
  import InputDate2 from "@/components/InputDate2.vue"
  import Select2 from "@/components/Select2.vue"
  import Button from "@/components/Button.vue"
  import CKEditor from "@/components/CKEditor.vue"
  import i18n from "@/plugins/i18n";
  import {useRoute} from "vue-router";
  import RequiredText from "@/components/RequiredText.vue"
  import {formatTodayDate} from "@/mixins/Helpers"

  const store = useStore()
  const route = useRoute()

  const emits = defineEmits(['load'])

  const props = defineProps({
    id: {
        type: String,
        required: true
    },
    date : {
      type : String,
      required : false
    }
  })

  const formLostData = ref({
    opportunity_id: route.params.id,
    reason_id: null,
    loss_motif: null,
    date: props.date ?? formatTodayDate()
  })

  const isLoadingLost = ref(false)

  const reasons = computed(() => store.getters['reasons/getReasons'])

  function closeModal(){
    $('#lostModal').modal('toggle')
  }

  function changeLostPipeline(){
    isLoadingLost.value = true
    store.dispatch('pipelines/changeInLostPipeline', formLostData.value)
        .then(res => {
          emits('load')
          window.toastr['success'](i18n.global.t("notification.status_lost_changed"))
        })
        .finally(() => {
          closeModal()
          isLoadingLost.value = false
       
        })
  }

  function getMotif(text){
    formLostData.value.loss_motif = text
  }

</script>

<style scoped></style>
